<template>
  <v-sheet class="d-flex align-center mr-3" color="transparent">
    <div class="secondary--text text-body-1">Exibir em:</div>

    <v-btn-toggle v-model="toggle" class="rounded-lg ml-2">
      <v-btn
        :color="toggle === 'metros' ? 'black' : 'white'"
        depressed
        height="36px"
        value="metros"
      >
        <div
          class="text-body-2 text-none"
          :class="toggle === 'metros' ? 'white--text' : 'black--text'"
        >
          m²
        </div>
      </v-btn>

      <v-btn
        :color="toggle === 'hectare' ? 'black' : 'white'"
        depressed
        height="36px"
        value="hectare"
      >
        <div
          class="text-body-2 text-none"
          :class="toggle === 'hectare' ? 'white--text' : 'black--text'"
        >
          ha
        </div>
      </v-btn>

      <v-btn
        :color="toggle === 'alqueire' ? 'black' : 'white'"
        depressed
        height="36px"
        value="alqueire"
      >
        <div
          class="text-body-2 text-none"
          :class="toggle === 'alqueire' ? 'white--text' : 'black--text'"
        >
          alq
        </div>
      </v-btn>
    </v-btn-toggle>
  </v-sheet>
</template>

<script>
export default {
  data: () => ({
    toggle: null,
  }),
  watch: {
    toggle(v) {
      this.$emit("change-units", v);
    },
  },
};
</script>
